import React, { Component } from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import { LabeledText } from '../LabeledText';
import { FieldHelpIcon } from '../../icon/FieldHelpIcon';
import { helpModalControl } from '../../modals/HelpModalControl';

class MinMaxSearchCardUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
  }

  handleHelpClick(e) {
    e.preventDefault();
    const { toggleHelpModal, helpModalId } = this.props;
    if (helpModalId) {
      toggleHelpModal(helpModalId);
    }
  }

  render() {
    const {
      children, min, max, className, helpModalId, minLabel, maxLabel,
    } = this.props;
    return (
      <Card className={`haz-inner-card ${className}`}>
        <CardBody>
          <CardTitle>
            <div className="haz-help-icon-inline">
              <span>{children}</span>
              {helpModalId && <span><FieldHelpIcon tooltipLabel={helpModalId} handleClick={this.handleHelpClick} /></span>}
            </div>
          </CardTitle>
          <div className="form-row">
            <LabeledText formGroupClassName={['col-sm-6']} model={min} label={minLabel} />
            <LabeledText formGroupClassName={['col-sm-6']} model={max} label={maxLabel} />
          </div>
        </CardBody>
      </Card>
    );
  }
}


MinMaxSearchCardUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  min: PropTypes.string.isRequired,
  max: PropTypes.string.isRequired,
  className: PropTypes.string,
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
};

MinMaxSearchCardUnwrapped.defaultProps = {
  className: '',
  helpModalId: '',
  minLabel: 'Min',
  maxLabel: 'Max',
};

export const MinMaxSearchCard = helpModalControl(MinMaxSearchCardUnwrapped);
